<panel width="800">
	<h1>{{ headline | translate }}</h1>
	@if (taskActionIsOpen()) {
		<section><panel-info-bar [infoData]="infoData" /></section>
	}
	@if (taskActionIsOpen()) {
		<section>
			@if (taskActionIsContact()) {
				@if (!statusIsOfferSent()) {
					<button confirm [selected]="nextAction == actions.meeting" [active]="permissionToEditTaskAction" [loader]="false" (click)="setNextAction(actions.meeting);"><icon type="calendar-alt" /> {{ 'sale.meeting' | translate }}</button>
					<button confirm [selected]="nextAction == actions.offerSent" [active]="permissionToEditTaskAction" [loader]="false" (click)="setNextAction(actions.offerSent);"><icon type="envelope" /> {{ 'sale.send-offer' | translate }}</button>
					<button [selected]="nextAction == actions.dialog" [active]="permissionToEditTaskAction" [loader]="false" (click)="setNextAction(actions.dialog);"><icon type="comments" /> {{ 'sale.dialog' | translate }}</button>
					<button ghost [selected]="nextAction == actions.noResponse" [active]="permissionToEditTaskAction" [loader]="false" (click)="setNextAction(actions.noResponse);"><icon type="times" /> {{ 'sale.no-reply' | translate }}</button>
					<button reject [selected]="nextAction == actions.rejected" [active]="permissionToEditTaskAction" [loader]="false" (click)="setNextAction(actions.rejected);"><icon type="times" /> {{ 'sale.rejected' | translate }}</button>
				}
				@else {
					<button reject [selected]="nextAction == actions.mailOfferRejected" [active]="permissionToEditTaskAction" [loader]="false" (click)="setNextAction(actions.mailOfferRejected);"><icon type="handshake-alt-slash" /> {{ 'sale.offer-rejected' | translate }}</button>
					<button confirm [selected]="nextAction == actions.createSale" [active]="permissionToEditTaskAction" [loader]="false" (click)="navigateToEditSale()"><icon type="hand-holding-dollar" /> {{ 'sale.create-sale' | translate }}</button>
				}
			}
			@if (taskActionIsMeeting()) {
				<button confirm [selected]="nextAction == actions.rescheduledMeeting" [active]="permissionToEditTaskAction" [loader]="false" (click)="setNextAction(actions.rescheduledMeeting);"><icon type="calendar-alt" /> {{ 'sale.meeting-moved' | translate }}</button>
				<button reject [selected]="nextAction == actions.meetingCancelled" [active]="permissionToEditTaskAction" [loader]="false" (click)="setNextAction(actions.meetingCancelled);"><icon type="calendar-times" /> {{ 'sale.meeting-cancelled' | translate }}</button>
				<button reject [selected]="nextAction == actions.offerRejected" [active]="permissionToEditTaskAction" [loader]="false" (click)="setNextAction(actions.offerRejected);"><icon type="handshake-alt-slash" /> {{ 'sale.offer-rejected' | translate }}</button>
				<button confirm [selected]="nextAction == actions.createSale" [active]="permissionToEditTaskAction" [loader]="false" (click)="navigateToEditSale()"><icon type="hand-holding-dollar" /> {{ 'sale.create-sale' | translate }}</button>
			}
		</section>

		@if (nextAction) {
			@if (allowFollowUp && (!requireFollowUpDate || !requireFollowUpTime)) {
				<section>
					<custom-input [label]="'sale.follow-up' | translate"
									[inputType]="inputTypeEnum.Switch"
									[value]="followUp"
									(valueChange)="followUp = $event" />
				</section>
			}
			<section>
				@if (createFollowUpTask) {
					<div>
						<div>
							<div><icon type="calendar-alt" /> {{followUpDate ? (followUpDate | customDate: 'shortDate') : 'sale.pick-date' | translate }}</div>
							<date-picker [(model)]="followUpDate" />
						</div>
						<div>
							<div><icon type="clock" /> {{followUpTime && followUpTime.currentTime != '' ? followUpTime.currentTime : 'sale.pick-time' | translate }}</div>
							<time-picker [(model)]="followUpTime" />
						</div>
					</div>
				}
				<div>
					@if (nextAction != actions.offerSent) {
						<div><icon type="file-edit" /> {{'sale.comment' | translate }}</div>
					}
					@else {
						<div><icon type="file-signature" /> {{'sale.send-offer' | translate }}</div>
					}
					@if (nextAction != actions.offerSent) {
						<custom-input [required]="true" [inputType]="inputTypeEnum.Textarea" [placeholder]="'sale.comment-placeholder' | translate" [(value)]="comments" />
					}
					@else {
						<task-action-mail-input #mailInput [contacts]="contacts" [taskAction]="taskAction" />
					}
				</div>
			</section>
			<section>
				<button confirm [active]="canSaveTaskChanges()" (click)="saveTaskChanges()">{{ 'general.save' | translate }}</button>
			</section>
		}
	}
	@if (company && taskAction?.id) {
		<task-action-log [showAllTaskActions]="true" [company]="company" [taskAction]="taskAction" (logUpdated)="refreshLog()" />
	}
</panel>
